import { render, staticRenderFns } from "./CallToActionsTwo.vue?vue&type=template&id=dcebc0e2&scoped=true&"
import script from "./CallToActionsTwo.vue?vue&type=script&lang=js&"
export * from "./CallToActionsTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcebc0e2",
  null
  
)

export default component.exports